import React, {
    useContext, useCallback
} from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { withRouter } from 'react-router-dom';
import { readViewModelValue } from 'gw-jutro-adapters-react';
import { TranslatorContext, IntlContext } from '@jutro/locale';
// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';
import { ViewModelForm } from 'gw-portals-viewmodel-react';
import metadata from './ConfirmationPage.metadata.json5';
import messages from '../../FNOL.messages';
import styles from './ConfirmationPage.module.scss';
import analyticsTracking from '../../../../../applications/claims-hub/src/app/AnalyticsTrackerUtil';

function ConfirmationPage(props) {
    const {
        history: { location: { state } },
        history,
        match: {
            params: { claimNumber }
        }
    } = props;
    const translator = useContext(TranslatorContext);
    const intl = useContext(IntlContext);
    const handlePrint = useCallback((e) => {
        e.preventDefault();
        window.print();
    }, []);

    const handleUploadSV = useCallback((e) => {
        e.preventDefault();
        const myWindow = window.open();
        myWindow.opener = null;
        myWindow.location = 'https://allianz.360sv.com/as/BDDjJhsW84FFmWRSt3GkzTLT';
        myWindow.target = 'blank';
    }, []);

    const handleBackToHome = useCallback(() => {
        if (appConfig.persona === 'policyholder') {
            return history.push('/home');
        }
        const redirectPath = _.get(state, 'redirectPath');
        if (redirectPath) {
            return history.push({
                pathname: redirectPath,
                state: 'claims'
            });
        }
        return false;
    }, [history, state]);

    const claimData = _.get(state, 'claimData');

    const coronetClaimNumberExt = _.get(claimData, 'coronetClaimNumber_Ext');
    const claimReportedDate = _.get(claimData, 'reportedDate_Ext');

    const overrideProps = {
        claimReferenceNumber: {
            visible: !!claimNumber,
            content: translator(messages.referenceNumber, { num: coronetClaimNumberExt })
        },
        claimSubmitDateTime: {
            visible: !!claimNumber,
            content: intl.formatDate(new Date(claimReportedDate), 
                { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric' } )
        },
        callButtonID: {
            content:
                appConfig.persona === 'policyholder'
                    ? messages.fnolBackToHome
                    : messages.fnolBackToHome
        }
    };

    const resolvers = {
        resolveCallbackMap: {
            handleBackToHome: handleBackToHome,
            handlePrint: handlePrint,
            handleUploadSV: handleUploadSV
        },
        resolveClassNameMap: styles
    };

    const readValue = useCallback(
        (id, path) => {
            return readViewModelValue(
                metadata.pageContent,
                id,
                path,
                overrideProps
            );
        },
        [overrideProps]
    );
    analyticsTracking.claimID(coronetClaimNumberExt);

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            overrideProps={overrideProps}
            callbackMap={resolvers.resolveCallbackMap}
            resolveValue={readValue}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );
}

ConfirmationPage.propTypes = {
    history: PropTypes.shape({
        location: PropTypes.shape({
            state: PropTypes.shape({
                redirectPath: PropTypes.string.isRequired
            }).isRequired
        }).isRequired,
        push: PropTypes.func.isRequired
    }).isRequired,
    match: PropTypes.shape({
        params: PropTypes.shape({
            claimNumber: PropTypes.string.isRequired
        })
    }).isRequired
};

export default withRouter(ConfirmationPage);
